<template>
  <div class="flex flex-col gap-y-3 overflow-y-auto pr-2">
    <ul class="flex gap-x-3 items-center">
      <strong>{{ state.model?.name }}</strong>
      <text class="text-gray-400 text-xs">{{ state.model?.number }}</text>
    </ul>
    <ul class="flex gap-x-5">
      <c_cell
        title="类型"
        :value="
          state.model?.d_office_expense_type_pname +
          ' - ' +
          state.model?.d_office_expense_type_name
        "
      />
      <c_cell title="支付渠道">
        <c_status
          arrName="Office_Expense_Apply_Payment_Method"
          :value="state.model?.payment_method"
          :key="state.model?.payment_method"
        />
      </c_cell>
      <c_cell title="乙方" v-if="state.model?.payment_method == 1">
        <template #default>
          <text>{{ state.model?.billUnit?.name }}</text>
          <text class="ml-1 text-xs text-gray-400">{{
            state.model?.billUnit?.number
          }}</text>
        </template>
      </c_cell>
    </ul>
    <c_cell title="申请说明" :value="state.model?.intro" />
    <div class="flex items-center text-gray-400 text-xs gap-x-2">
      <text class="text-sm text-gray-600">
        {{ state.model?.add_admin_name }}
      </text>
      <text>{{ state.model?.add_department_name }}</text>
      <text class="ml-1">{{ state.model?.create_time }} 申请</text>
    </div>
    <template v-if="state.model.status == 2">
      <c_cell title="付款说明" :value="state.model.transaction_remark" />
      <c_cell title="付款附件">
        <template #default>
          <div
            class="flex flex-wrap gap-x-5 gap-y-2"
            v-if="state.model?.transaction_attachment?.length > 0"
          >
            <text
              v-for="file in state.model?.transaction_attachment"
              :key="item"
              class="hover:underline cursor-pointer text-green-700"
              @click="$openFile(file.file_url)"
            >
              {{ file.filename }}
            </text>
          </div>
          <text v-else>-</text>
        </template>
      </c_cell>
      <div class="flex items-center text-gray-400 text-xs gap-x-2">
        <text class="text-sm text-gray-600">
          {{ state.model?.transaction_admin_name }}
        </text>
        <text>{{ state.model?.transaction_department_name }}</text>
        <text class="ml-1">{{ state.model?.transaction_time }} 付款</text>
      </div>
    </template>
    <ul class="grid items-center" style="grid-template-columns: 1fr auto auto">
      <strong>采购明细</strong>
      <strong>合计金额：</strong>
      <c_money
        :value="state.model?.amount"
        :key="state.model?.amount"
        :size="18"
        bold
      />
    </ul>
    <div>
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        height="auto"
      >
        <el-table-column
          prop="date"
          label="发生日期"
          align="center"
          :width="120"
        />
        <el-table-column
          prop="money"
          label="费用金额"
          align="right"
          :width="120"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column
          prop="intro"
          label="费用说明"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="附件">
          <template #default="{ row }">
            <c_UploadFile
              v-if="row.attachment?.length > 0"
              :key="row.attachment"
              :value="row.attachment"
              :showAdd="false"
              :showText="true"
            />
            <text v-else>-</text>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <strong>审核进度</strong>
    <el-steps :active="10" align-center>
      <el-step
        v-for="item in state.flowApproveStepList"
        :key="item"
        :title="item.step_name"
        :description="state.model.create_time"
      >
        <template #description>
          <div class="flex flex-col items-center">
            <template v-if="item.status">
              <ul class="flex gap-x-1">
                <c_status
                  arrName="Common_Check_Status"
                  :value="item.status"
                  showBg
                />
                <text>{{ item.approve_admin_name }}</text>
                <text>{{ item.approve_department_name }}</text>
              </ul>
              <text>{{ item.approve_time }}</text>
            </template>
            <c_status
              v-else
              arrName="Common_Check_Status"
              :value="item.status"
              showBg
            />
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { officeExpenseApply_search } from "@/http/bangongfeiyong";
import { ElMessageBox } from "element-plus";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        id: props.id,
      },
      meeting: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.id) {
        officeExpenseApply_search(props.id).then((res) => {
          if (res.status == 200) {
            const {
              info,
              flowApproveStepList,
              officeExpenseApplyRelationList,
            } = res.data?.data || {};
            state.model = info;
            state.list_data = officeExpenseApplyRelationList;
            state.flowApproveStepList = flowApproveStepList;
          }
        });
      }
    };

    const onSubmit = (pass) => {
      if (!state.remark) {
        ElMessage.warning("请输入审批说明！");
        return false;
      }

      ElMessageBox.confirm(
        `您确定<strong style="color: ${pass == 1 ? "#080" : "#f00"};">${
          pass == 1 ? "同意" : "拒绝"
        }</strong>该核算申请吗？`,
        "核算审批",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meetingacounting_approve({
          id: [props.id],
          status: pass,
          msg: state.remark,
        }).then((res) => {
          post_response(res, () => {
            setTimeout(() => {
              emit("close", true);
            }, 500);
          });
        });
      });
    };
    return { state, formDom, onSubmit };
  },
};
</script>

<style lang="less" scoped></style>
